import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  Divider,
  Slider,
  Tooltip
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { padding, width } from "@mui/system";

// const categories = [
//   "Electronics",
//   "IT",
//   "Manufacturing",
//   "Mechanical",
//   "Sales",
//   "Admin"
// ];

const experiences = ["0-1 Years", "1-3 Years", "3-5 Years", "5+ Years"];
const jobTypes = ["Full Time", "Part Time", "Contract", "Internship"];

export default function JobFilterSidebar({ onChange ,categories=[] }) {
  const [filters, setFilters] = useState({
    jobMode: [],
    category: [],
    experience: [],
    jobType: [],
    salary: [0, 10] // LPA
  });

  const toggleCheckbox = (field, value) => {
    setFilters((prev) => {
      const updated = prev[field].includes(value)
        ? prev[field].filter((v) => v !== value)
        : [...prev[field], value];

      const newFilters = { ...prev, [field]: updated };
      onChange?.(newFilters);
      return newFilters;
    });
  };

const handleSalaryChange = (_, value) => {
  // Clear any existing timeout
  if (window.salaryTimeout) {
    clearTimeout(window.salaryTimeout);
  }
  
  // Set new timeout for 500ms
  window.salaryTimeout = setTimeout(() => {
    const newFilters = { ...filters, salary: value };
    setFilters(newFilters);
    onChange?.(newFilters);
  }, 500); // 500ms delay
};

  const clearFilters = () => {
    const reset = {
      jobMode: [],
      category: [],
      experience: [],
      jobType: [],
      salary: [0, 10]
    };
    setFilters(reset);
    onChange?.(reset);
  };
const getScrollableStyle = (listLength) => ({
  maxHeight: listLength > 5 ? 200 : "auto",
  width: "100%",
  overflowY: listLength > 5 ? "auto" : "visible",
  overflowX: "hidden",  
  /* Hide scrollbar */
  scrollbarWidth: "none",        // Firefox
  msOverflowStyle: "none",       // IE & Edge
  "&::-webkit-scrollbar": {
    display: "none",             // Chrome, Safari
  },
});

  return (
    <Box
      sx={{
        width: 260,
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        p: 2,
       pt: { xs: 7, sm: 7 },
        bgcolor: "#fff",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" fontWeight={600}>
          Filters
        </Typography>
        <Button variant="contained"  sx={{
                                bgcolor: "#005E82",
                                "&:hover": { bgcolor: "#005070" },
                                textTransform: "none",
                                fontFamily: "Poppins-Medium",
                               color: "#fff",
                                padding: "10px",
                                width: "102px",
                                height: "44px",
                                borderRadius: "8px",
                              }} size="small" onClick={clearFilters}>
          Clear Filters
        </Button>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Job Mode */}
      {/* <Accordion defaultExpanded elevation={0} sx={getScrollableStyle(3)}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={500}>Job Mode</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {["Hybrid", "Remote", "In-Office"].map((mode) => (
            <FormControlLabel
              key={mode}
              control={
                <Checkbox
                  checked={filters.jobMode.includes(mode)}
                  onChange={() => toggleCheckbox("jobMode", mode)}
                />
              }
              label={mode}
            />
          ))}
        </AccordionDetails>
      </Accordion> */}
{/* 
      <Divider /> */}

      {/* Job Category */}
      <Accordion elevation={0}  expanded={categories?.length > 0}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={500}>Job Category {categories?.length > 0 ? `(${categories.length})` : ""} {filters?.category?.length > 0 ? `selected (${filters.category.length})` : ""}</Typography>
        </AccordionSummary>

<AccordionDetails sx={getScrollableStyle(categories?.length)}>
  {categories.map((cat) => (
    <FormControlLabel
      key={cat}
      sx={{ width: "100%" }}
      control={
        <Checkbox
          checked={filters.category.includes(cat)}
          onChange={() => toggleCheckbox("category", cat)}
        />
      }
      label={
        <Tooltip title={cat} arrow>
          <Typography
            sx={{
              maxWidth: "80%",     // 👈 uses remaining space
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "block",
            }}
          >
            {cat}
          </Typography>
        </Tooltip>
      }
    />
  ))}
</AccordionDetails>

      </Accordion>

      <Divider />

      {/* Experience */}
      <Accordion elevation={0} sx={getScrollableStyle(experiences.length)} expanded={experiences?.length > 0}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={500}>Experience</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {experiences.map((exp) => (
            <FormControlLabel
              key={exp}
              control={
                <Checkbox
                  checked={filters.experience.includes(exp)}
                  onChange={() => toggleCheckbox("experience", exp)}
                />
              }
              label={exp}
            />
          ))}
        </AccordionDetails>
      </Accordion>

      <Divider />

      {/* Job Type */}
      {/* <Accordion elevation={0} sx={getScrollableStyle(jobTypes.length)}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={500}>Job Type</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {jobTypes.map((type) => (
            <FormControlLabel
              key={type}
              control={
                <Checkbox
                  checked={filters.jobType.includes(type)}
                  onChange={() => toggleCheckbox("jobType", type)}
                />
              }
              label={type}
            />
          ))}
        </AccordionDetails>
      </Accordion> */}

      <Divider />

      {/* Salary */}
      <Accordion elevation={0} expanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={500}>
            Salary (₹ LPA)
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Slider
            value={filters.salary}
            onChange={handleSalaryChange}
            valueLabelDisplay="auto"
            min={0}
            max={20}
          />
          <Typography variant="body2" color="text.secondary">
            ₹{filters.salary[0]} LPA – ₹{filters.salary[1]} LPA
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
